var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-30.000000, -200.000000)",
    fill: "#5D87AF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,207 L41,201.5 L46.5,207 L41,207 Z M32.25,200 C31.00125,200 30,200.801 30,201.8 L30,216.2 C30,217.194113 31.0073593,218 32.25,218 L45.75,218 C46.9926407,218 48,217.194113 48,216.2 L48,205.4 L41.25,200 L32.25,200 Z",
    id: "icon_file"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e21fe763e1ede07684675702ba90586c.svg";
export { ForwardRef as ReactComponent };